import api from './index';

interface ServicePhoneNumber {
    callCenterPhone: string;
}
export const getServicePhoneNumber = async () => {
    const { data } = await api.get<ServicePhoneNumber>('/v4/service-phone-number');
    return data;
};

export const HelpService = {
    getServicePhoneNumber,
};
